import { exhaustiveSwitchWithDefault } from "@faire/web/common/exhaustiveSwitchWithDefault";
import { cn } from "@faire/web/tools/cn";

export enum DeprecatedTrackingTargetType {
  COMPONENT = "COMPONENT",
  COMPONENT_GROUP = "COMPONENT_GROUP",
  ICON = "ICON",
  // TYPOGRAPHY = "TYPOGRAPHY",
  LOGO = "LOGO",
}

export const getLegacyTrackingCls = (
  targetType: DeprecatedTrackingTargetType
) => {
  switch (targetType) {
    case DeprecatedTrackingTargetType.COMPONENT:
      return "fslegacy-component";
    case DeprecatedTrackingTargetType.COMPONENT_GROUP:
      return "fslegacy-component-group";
    case DeprecatedTrackingTargetType.ICON:
      return "fslegacy-icon";
    // case DeprecatedTrackingTargetType.TYPOGRAPHY:
    //   return "fslegacy-typography";
    case DeprecatedTrackingTargetType.LOGO:
      return "fslegacy-logo";
    default:
      return exhaustiveSwitchWithDefault("")(targetType);
  }
};

export const legacyComponentCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getLegacyTrackingCls(DeprecatedTrackingTargetType.COMPONENT));

export const legacyComponentGroupCls = (...cls: Array<string | undefined>) =>
  cn(
    ...cls,
    getLegacyTrackingCls(DeprecatedTrackingTargetType.COMPONENT_GROUP)
  );

export const legacyIconCls = (...cls: Array<string | undefined>) =>
  cn(...cls, getLegacyTrackingCls(DeprecatedTrackingTargetType.ICON));

// TODO(alipianu): roll this out
// export const legacyTypographyCls = (...cls: Array<string | undefined>) =>
//   cn(...cls, getLegacyTrackingCls(DeprecatedTrackingTargetType.TYPOGRAPHY));
